import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as HitSearch from 'actions/HitSearch';

export function* onGetRequest({ params, cb }) {
  const size = params.size || 30
  const page = params.page || 0
  try {
    const searchResult = yield axios.get(`/api/hitsearch/?words=${encodeURIComponent(params.words)}&size=${size}&page=${page}`);
    if(page === 0) {
      yield put(HitSearch.onGetSuccess(searchResult.data || {}));
    }
    else {
      yield put(HitSearch.onGetNextSuccess(searchResult.data || {}));
    }
    cb && cb(null, searchResult.data);
  } catch (e) {
    if(page === 0) {
      yield put(HitSearch.onGetFailure({ message: e.toString(), error: e }));
    }
    else {
      yield put(HitSearch.onGetNextFailure({ message: e.toString(), error: e }));
    }
    cb && cb(e);
  }
}